import feature1 from "../assets/images/feature_1.png";
import feature2 from "../assets/images/feature_2.png";
import feature3 from "../assets/images/feature_3.png";
import feature4 from "../assets/images/feature_4.png";
import feature5 from "../assets/images/feature_5.png";
import feature6 from "../assets/images/feature_6.png";
import service1 from "../assets/images/service1.png";
import service2 from "../assets/images/service2.png";
import service3 from "../assets/images/service3.png";
import service4 from "../assets/images/service4.png";
import service5 from "../assets/images/service5.png";

export const FEATURES = [
  {
    key: "ecoFriendly",
    title: "Eco Friendly",
    description:
      "We use high-quality cleaning agents and equipment as well as premium materials.",
    icon: feature1,
  },
  {
    key: "waterConservative",
    title: "Water Conservative",
    description:
      "We use high-quality cleaning agents and equipment as well as premium materials.",
    icon: feature2,
  },
  {
    key: "timeSaving",
    title: "Time Saving",
    description:
      "We use high-quality cleaning agents and equipment as well as premium materials.",
    icon: feature3,
  },
  {
    key: "hassleFree",
    title: "Hassle Free",
    description:
      "We use high-quality cleaning agents and equipment as well as premium materials.",
    icon: feature4,
  },
  {
    key: "userFriendly",
    title: "User Friendly",
    description:
      "We use high-quality cleaning agents and equipment as well as premium materials.",
    icon: feature5,
  },
  {
    key: "availability",
    title: "24/7 Availability",
    description:
      "We use high-quality cleaning agents and equipment as well as premium materials.",
    icon: feature6,
  },
];

export const SERVICES = [
  {
    key: "carDetailing",
    title: "Car Detailing",
    description: `
      Mr. Steamer will make sure to
      remove both visible and invisible
      containments from interior and by
      polishing the your vehicles Exterior
      with blemish-free finish to keep
      your Vehicles in its best possible
      condition
      `,
    icon: service1,
  },
  {
    key: "tyreReplacement",
    title: "Tyre Replacement",
    description: `Let us know the details and
      we will take care of it at your
      location`,
    icon: service2,
  },
  {
    key: "oilChange",
    title: "Oil Change",
    description: `Not just wash we are here to
      take care your to provide
      servicing for your engine also.`,
    icon: service3,
  },
  {
    key: "carWash",
    title: "Car wash",
    description: `Now no need to go anywhere
    Order Mr. Steamer A at your
    door step. Mr. Steamer Car 
    wash service team is available
    24/7.`,
    icon: service2,
  },
  {
    key: "roadSideAssistance",
    title: "Road Side Assistance",
    description: `Need help! Mr. Steamer will
    make sure to save your day.`,
    icon: service4,
  },
  {
    key: "carToeService",
    title: "Car Toe Service",
    description: `Now Just open your Mobile
    order`,
    icon: service5,
  },
];

export const SARS = [
  {
    key: "sar50PerYear",
    title: "SAR 50/Year",
    descriptionEn: [
      "Free Car wash after every 6 washes",
      "Complementary Car Perfume",
      "Free Battery Check",
    ],
    descriptionAr: [
      "غسيل مجاني للسيارة بعد كل 6 غسلات",
      "عطر السيارة التكميلي",
      "فحص البطارية مجانا",
    ],
  },
  {
    key: "sar70PerYear",
    title: "SAR 70/Year",
    descriptionEn: [
      "Free car wash after every 5 washes",
      "Complementary Car Perfume",
      "Free Battery Check",
    ],
    descriptionAr: [
      "غسيل مجاني للسيارة بعد كل 5 عمليات غسيل",
      "عطر السيارة التكميلي",
      "فحص البطارية مجانا",
    ],
  },
  {
    key: "sar100PerYear",
    title: "SAR 100/Year",
    descriptionEn: [
      "Free Car wash after every 3 washes",
      "Free Car Perfume",
      "Free Radiator water level check & refill",
      "Free Battery Check",
      "Polished for tyres even with normal car wash",
    ],
    descriptionAr: [
      "غسيل مجاني للسيارة بعد كل 3 غسلات",
      "عطر سيارة مجاني",
      "فحص مستوى ماء الراديتر مجانا",
      "فحص البطارية مجانا",
      "ملمع للإطارات حتى مع الغسيل العادي للسيارة",
    ],
  },
];

export const SUADIA_CITIES = [
  "Riyadh",
  "Jeddah",
  "Mecca",
  "Medina",
  "Dammam",
  "Taif",
  "Tabuk",
  "Buraydah",
  "Abha",
  "Khobar",
  "Jubail",
];

export const JOB_TYPES = [
  { key: "partTime", name: "Part Time", value: "partTime" },
  { key: "fullTime", name: "Full Time", value: "FullTime" },
  {
    key: "earnWithYourVehicles",
    name: "Earned With your Vehicles",
    value: "earnWithVehicles",
  },
];
